/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { useState } from 'react';
import style from './hamburgerStyle';
import { SiteLink } from '../../components';
import { useAuth } from '../../auth';
import { useRouter } from '../../components';

export function Hamburger({ opened, toggleMenu, scrolled }) {
  const auth = useAuth();
  const router = useRouter();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  
  // Check if user is logged in
  const isLoggedIn = !!(auth.user || auth.session);
  
  // If logged in, go to members-area; otherwise go to login
  const membersLink = isLoggedIn ? '/members-area' : '/login';

  const handleSignOut = (e) => {
    e.preventDefault();
    auth.signout().then(() => {
      setDropdownOpen(false);
      router.push('/');
    });
  };

  const handleSignIn = (e) => {
    e.preventDefault();
    setDropdownOpen(false);
    router.push('/login');
  };

  return (
    <div css={style.hamburgerContainer}>
      <div 
        css={style.membersAreaWrapper}
        onMouseEnter={() => setDropdownOpen(true)}
        onMouseLeave={() => setDropdownOpen(false)}
      >
        <SiteLink
          to={membersLink}
          css={style.membersAreaLink}
        >
          MEMBERS AREA
        </SiteLink>
        {dropdownOpen && (
          <div css={style.dropdown}>
            <ul css={style.dropdownMenu}>
              {isLoggedIn ? (
                <>
                  <li css={style.dropdownItem}>
                    <SiteLink to="/members-area/abna-conferences" css={style.dropdownLink}>ABNA Conferences</SiteLink>
                  </li>
                  <li css={style.dropdownItem}>
                    <SiteLink to="/members-area/abna-seminars" css={style.dropdownLink}>ABNA Seminars</SiteLink>
                  </li>
                  <li css={style.dropdownItem}>
                    <SiteLink to="/members-area/abna-agm-minutes-financial-reports" css={style.dropdownLink}>AGM Minutes & Financial Reports</SiteLink>
                  </li>
                  {/* <li css={style.dropdownItem}>
                    <SiteLink to="/members-area/abna-sig-resources" css={style.dropdownLink}>ABNA SIG Resources</SiteLink>
                  </li> */}
                  <li css={style.dropdownItem}>
                    <SiteLink to="/members-area/abna-sig-resources" css={style.dropdownLink}>ABNA Special Interest Groups</SiteLink>
                  </li>
                  <li css={style.dropdownItem}>
                    <SiteLink to="/members-area/my-account" css={style.dropdownLink}>My Account</SiteLink>
                  </li>
                  <li css={style.dropdownDivider}></li>
                  <li css={style.dropdownItem} onClick={handleSignOut}>
                    <a href="#" css={style.dropdownLink}>LOG OUT</a>
                  </li>
                </>
              ) : (
                <li css={style.dropdownItem} onClick={handleSignIn}>
                  <a href="#" css={style.dropdownLink}>SIGN IN</a>
                </li>
              )}
            </ul>
          </div>
        )}
      </div>
      <button css={[style.button, scrolled && style.buttonScrolled]} type="button" aria-label="Menu" onClick={toggleMenu}>
        <span css={style.hamburger}>
          <span css={[style.line1, opened && style.lineActive1]}></span>
          <span css={[style.line2, opened && style.lineActive2]}></span>
          <span css={[style.line3, opened && style.lineActive3]}></span>
        </span>
      </button>
    </div>
  )
}